/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoteVo } from './NoteVo';
import {
    NoteVoFromJSON,
    NoteVoFromJSONTyped,
    NoteVoToJSON,
    NoteVoToJSONTyped,
} from './NoteVo';

/**
 * 
 * @export
 * @interface PageDataNoteVo
 */
export interface PageDataNoteVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataNoteVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataNoteVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataNoteVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<NoteVo>}
     * @memberof PageDataNoteVo
     */
    records?: Array<NoteVo>;
}

/**
 * Check if a given object implements the PageDataNoteVo interface.
 */
export function instanceOfPageDataNoteVo(value: object): value is PageDataNoteVo {
    return true;
}

export function PageDataNoteVoFromJSON(json: any): PageDataNoteVo {
    return PageDataNoteVoFromJSONTyped(json, false);
}

export function PageDataNoteVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataNoteVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(NoteVoFromJSON)),
    };
}

export function PageDataNoteVoToJSON(json: any): PageDataNoteVo {
    return PageDataNoteVoToJSONTyped(json, false);
}

export function PageDataNoteVoToJSONTyped(value?: PageDataNoteVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(NoteVoToJSON)),
    };
}

